import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Wallet, Users, UserIcon, Trophy } from 'lucide-react';

const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { icon: <Home className="w-5 h-5" />, label: 'Home', path: '/dashboard' },
    { icon: <Wallet className="w-5 h-5" />, label: 'Wallet', path: '/dashboard/wallet' },
    { icon: <Users className="w-5 h-5" />, label: 'Team', path: '/dashboard/my-team' },
    { icon: <UserIcon className="w-5 h-5" />, label: 'Profile', path: '/dashboard/profile' },
    { icon: <Trophy className="w-5 h-5" />, label: 'Rank', path: '/dashboard/leaderboard' },
  ];

  return (
    <div className="fixed bottom-0 w-full bg-gradient-to-t from-[#0a0a0f] via-[#0f0f1a] to-transparent backdrop-blur-xl border-t border-purple-500/20 z-40">
      <div className="max-w-7xl mx-auto px-4 py-2">
        <div className="flex justify-around items-center">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <motion.button
                key={item.label}
                whileHover={{ scale: 1.1, y: -3 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate(item.path)}
                className={`flex flex-col items-center gap-1 py-1 px-3 rounded-lg transition-all ${
                  isActive ? 'text-purple-400' : 'text-gray-500 hover:text-gray-300'
                }`}
              >
                {item.icon}
                <span className="text-[10px] font-rajdhani font-bold">{item.label}</span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BottomNav;